(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nua-bundle-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  var form = document.querySelector('[data-nua-bundle-form]');
  if (!form) return;
  var label = form.querySelector('[data-cta-label]');
  var radios = form.querySelectorAll('input[name="id"]');
  function sync() {
    var checked = form.querySelector('input[name="id"]:checked');
    if (!checked || !label) return;
    var card = checked.closest('.nua-bundle__opt');
    var priceEl = card ? card.querySelector('.nua-bundle__price') : null;
    var txt = priceEl ? priceEl.textContent.trim() : '';
    label.textContent = txt ? 'Comprar ahora · ' + txt : 'Comprar ahora';
    document.documentElement.setAttribute('data-nua-bundle', checked.closest('[data-opt-id]')?.dataset.optId || '');
    document.dispatchEvent(new CustomEvent('nua:bundle-change', { detail: { variant_id: checked.value } }));
  }
  radios.forEach(function (r) { r.addEventListener('change', sync); });
  sync();

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tickShipping() {
    var countdownEls = document.querySelectorAll('[data-nua-shipping-countdown]');
    var dayEls = document.querySelectorAll('[data-nua-shipping-day]');
    if (!countdownEls.length) return;
    var now = new Date();
    var deadline = new Date();
    deadline.setHours(14, 0, 0, 0);
    var today = now < deadline;
    if (!today) deadline.setDate(deadline.getDate() + 1);
    var diff = deadline - now;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var txt = (h > 0 ? h + 'h ' : '') + pad(m) + 'm ' + pad(s) + 's';
    countdownEls.forEach(function (el) { el.textContent = txt; });
    dayEls.forEach(function (el) { el.textContent = today ? 'HOY' : 'MAÑANA'; });
  }
  tickShipping();
  setInterval(tickShipping, 1000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nua-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
  var el = document.querySelector('[data-nua-sticky-atc]');
  if (!el) return;
  var brand = el.getAttribute('data-nua-brand') || 'mask';
  var nameEl = el.querySelector('[data-nua-sticky-name]');
  var priceEl = el.querySelector('[data-nua-sticky-price]');

  function updateMask(bundle) {
    if (!nameEl || !priceEl) return;
    if (bundle === 'pack') { nameEl.textContent = 'Pack Ritual'; priceEl.textContent = '94,90 €'; }
    else { nameEl.textContent = 'Máscara LED Pro'; priceEl.textContent = '79,90 €'; }
  }
  function updateArena(bundle) {
    if (!nameEl || !priceEl) return;
    if (bundle === 'pack') { nameEl.textContent = 'Pack Regalo x2'; priceEl.textContent = '69,90 €'; }
    else { nameEl.textContent = 'Kit Ritual'; priceEl.textContent = '39,90 €'; }
  }

  if (brand === 'arena') {
    document.addEventListener('arena:bundle-change', function (e) { updateArena(e.detail.bundle); });
  } else {
    document.addEventListener('nua:bundle-change', function (e) { updateMask(e.detail.bundle); });
  }

  var showAt = 400;
  function onScroll() {
    el.setAttribute('data-visible', window.scrollY > showAt ? 'true' : 'false');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
  } catch(e) { console.error(e); }
})();

})();
